/* eslint-disable  */
import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import UpdateContent from '../../Services/Mutations/UpdateContent'
import { ToastContainer, toast } from 'react-toastify'

export default function EditDisc(props) {
	const { index, item, description, publishedContentsListdata } = props
	const [popUpVisible, setPopUpVisible] = useState(false)
	const [editedvalue, seteditedvalue] = useState(description)
	const [editedAttribute, seteditedAttribute] = useState()
	const [Desclength, setDesclength] = useState()

	const editpop = () => {
		if (popUpVisible === true) {
			setPopUpVisible(false)
		} else {
			setPopUpVisible(true)
		}
	}

	const toastStyle = {
		position: 'top-right',
		autoClose: 2000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	}

	
	function editiconbutton() {
		console.log('editiconbutton')
		setPopUpVisible(true)
	}

	const handleEditDesc = (e, index) => {
		seteditedvalue(e.target.value)
		setDesclength(e.target.value.length)

		seteditedAttribute(e.target.name)
	}

	const stripTypenames = value => {
		if (Array.isArray(value)) {
			return value.map(stripTypenames)
		}

		if (value !== null && typeof value === 'object') {
			const newObject = {}
			for (const property in value) {
				if (property !== '__typename') {
					newObject[property] = stripTypenames(value[property])
				}
			}

			return newObject
		}

		return value
	}

	const handlesaveDesc = async (e, index) => {
		const pkvalue = publishedContentsListdata.items[index].PK
		const skvalue = publishedContentsListdata.items[index].SK
		console.log(publishedContentsListdata.items[index], pkvalue, skvalue, 'publishedContentsListdata.items[index]')
		const publishedContentItem = publishedContentsListdata.items[index]
		const publishedContetDataObjects = publishedContentsListdata.items[index].contentMetaInfo.storyDetails

		publishedContetDataObjects[editedAttribute] = editedvalue
		publishedContentItem.contentMetaInfo.storyDetails = publishedContetDataObjects

		// delete inputobj.contentMetaInfo.thumbnailURL
		const storydetailsObj = item.contentMetaInfo.storyDetails
		storydetailsObj[editedAttribute] = editedvalue
		const input = {
			// ...publishedContentItem
			contentPlanner: item.contentPlanner,
			createdAs: item.createdAs,
			creatorHandle: '@YouSayEditor',
			creatorName: item.originalCreatorName,
			contentType: item.contentType,
			contentMainCategory: item.contentMainCategory,
			creatorUUID: item.creatorUUID,
			originalCreator:
				item.creatorUUID,
			type: 'content',
			allowShare: item.allowShare,
			createInBoxOffice: item.createInBoxOffice,
			allowComments: item.allowComments,
			genderSpecific: item.genderSpecific,
			tagsWithGenderTarget: item.tagsWithGenderTarget,
			peopleValues: item.peopleValues,
			syncToYousaytv: item.syncToYousaytv,
			contentMetaInfo: {
				storyDetails: storydetailsObj,

				coverStoryDetails: item.contentMetaInfo.coverStoryDetails,
				mcqDetails: item.contentMetaInfo.mcqDetails,
				pollDetails: item.contentMetaInfo.pollDetails,
				slideShowDetails: item.contentMetaInfo.slideShowDetails,
			},
			scheduledDate: item.scheduledDate,
			scheduledTime: item.scheduledTime,
			// need to change
			contentStatus: props.status ? props.status : 'draft',
			// =
			contentVersion: item.contentVersion,
			selectedAutoExpireDate: item.selectedAutoExpireDate,
			selectedAutoDeleteDate: item.selectedAutoDeleteDate,
			contentLanguages: item.contentLanguages,
			targetAreas: item.targetAreas,
			targetAreaV2: item.targetAreaV2,

		}

		if (item.contentMetaInfo.contentImage) {
			input.contentMetaInfo.contentImage = item.contentMetaInfo.contentImage.substring(
				item.contentMetaInfo.contentImage.indexOf('public'),
			)
		}

		input.contentMetaInfo.contentImages = [item.contentMetaInfo.contentImage.substring(
			item.contentMetaInfo.contentImage.indexOf('public'),
		)]

		input.PK = item.PK
		input.SK = item.SK
		input.pnPriority = item.pnPriority
		input.pnDescription = item.pnDescription
		input.pnDescription_Te = item.pnDescription_Te
		input.pnDescription_En = item.pnDescription_En
		input.pnDescription_Hi = item.pnDescription_Hi
		input.scheduledTime = item.scheduledTime
		input.scheduledTime_En = item.scheduledTime_En
		input.scheduledTime_Hi = item.scheduledTime_Hi
		input.scheduledTime_Te = item.scheduledTime_Te

		input.scheduledDate_En = item.scheduledDate_En
		input.scheduledDate_Te = item.scheduledDate_Te
		input.scheduledDate_Hi = item.scheduledDate_Hi
		input.creatorVideoHashTag1 = item.creatorVideoHashTag1
		input.creatorVideoHashTag2 = item.creatorVideoHashTag2
		input.creatorVideoHashTag3 = item.creatorVideoHashTag3
		input.creatorVideoHashTag4 = item.creatorVideoHashTag4
		input.creatorVideoHashTag1AndType = item.creatorVideoHashTag1AndType
		input.creatorVideoHashTag2AndType = item.creatorVideoHashTag2AndType
		input.creatorVideoHashTag3AndType = item.creatorVideoHashTag3AndType
		input.creatorVideoHashTag4AndType = item.creatorVideoHashTag4AndType

		input.contentCategory1 = item.contentCategory1
		input.contentCategory2 = item.contentCategory2
		input.contentCategory3 = item.contentCategory3

		input.inAppMessageDetails = item.inAppMessageDetails
		input.isPushRankActive = item.isPushRankActive
		input.positionFromTop = item.positionFromTop
		input.tempPositionFromTop = item.tempPositionFromTop
		input.showSticky = item.showSticky
		input.stickyTargetImpressions = item.stickyTargetImpressions
		input.stickyEndDateTime = item.stickyEndDateTime
		input.pushRankUpTo = item.pushRankUpTo
		input.pushRankTo = item.pushRankTo
		input.stickyPost = item.stickyPost
		input.isInAppMessage = item.isInAppMessage

		input.storyType = item.storyType
		input.wordPressInfo = item.wordPressInfo
		input.addedTargetAreaCategories = item.addedTargetAreaCategories
		input.addedNewsCategories = item.addedNewsCategories
		input.targetAreaCategoriesArr = item.targetAreaCategoriesArr
		input.newsCategoriesArr = item.newsCategoriesArr

		console.log(input, 'input===========1212')
		const contentDetailsval = stripTypenames(input)

		console.log(input, 'inputobjinputobj==========')
		const response = await UpdateContent(contentDetailsval)

		console.log(response, 'responsedesc')
		props.getUnpublishedContentsList()
		setPopUpVisible(false)
		console.log(response.statusCode, 'resopnseee')

		switch (response.statusCode) {
			case 'A186':
				toast.success('Description Updated Successfully', toastStyle)
				break
			default:
				toast.error('Failed to update Description', toastStyle)
		}

		setPopUpVisible(false)

		console.log(input, 'inputobjinputobjdesccc==========')
	}

	const handlecancelDesc = index => {
		setPopUpVisible(false)
	}

	return (
		<div>
			<button style={{
				border: '0px solid rgba(0, 0, 0, 0.1)',
			}} onClick={editiconbutton}>
				<i style={{ fontSize: '12px' }} className='fas fa-pencil-alt fa-lg'></i>
			</button>

			{popUpVisible ? (<Modal show={editpop} fullscreen={'md-down'} onHide={() => setPopUpVisible(false)}>
				<Modal.Header >
					<Modal.Title>Edit Description</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className='main'>
						<textarea
							id='firstname'
							value={editedvalue}
							type='firstname'
							name='storyCardDescription_Te'
							placeholder='Firstname'
							onChange={e => handleEditDesc(e, index)}
							required
							rows={7}
							cols='45'
						/>
						<div>

							{Desclength > 0 ? <button className='btn btn-primary' type='submit' style={{ margin: '5px 5px' }} value='Submit' onClick={e => handlesaveDesc(e, index)
							}>

								Save
							</button> :
								<><p style={{ color: 'red' }}>Please enter any data</p>
									<button disabled className='btn btn-primary' type='submit' style={{ margin: '5px 5px' }} value='Submit' onClick={e => handlesaveDesc(e, index)
									}>

										Save
									</button></>}
							<button className='btn btn-primary' style={{ margin: '5px 5px' }} type='reset' value='Reset' onClick={() => handlecancelDesc(index)}>

								Cancel
							</button>
						</div>
					</div>
				</Modal.Body>
			</Modal>) : ''}

		</div>
	)
}
